// extracted by mini-css-extract-plugin
export var cartContainer = "_n4-4";
export var gray = "_n4-1";
export var itemContainer = "_n4-2";
export var itemDetails = "_n4-3";
export var strong = "_n4-0";